import { combineReducers } from 'redux';
import LiberacionEstudios from './LiberacionEstudios';
import EntregaEstudios from './EntregaEstudios';

export default combineReducers({
  LiberacionEstudios,
  EntregaEstudios,
});
